import React, { useState } from 'react'
import { Button, Spin } from 'antd'
import { useSelector } from 'react-redux'
import CardForm from '../CardForm'
import LinkBankAccountButton from '../LinkBankAccountButton/LinkBankAccountButton'
import { selectIsPaymentMethodLoading } from '@reducers/paymentMethod/paymentMethodSelectors'


import styles from './CardOrBankAccount.module.scss'

const CardOrBankAccount = (props) => {
  const {
    onAddCard,
    onClickLinkBankAccount,
    onClickSwitchToBankAccount,
    onAddPaymentMethodSuccess,
  } = props

  const [showCardForm, setShowCardForm] = useState(false)
  const isPaymentMethodLoading = useSelector(selectIsPaymentMethodLoading)

  const handleAddCard = () => {
    onAddCard()
    setShowCardForm(true)
  }


  return (
    <Spin
      tip="loading..."
      spinning={isPaymentMethodLoading}
      size="large"
    >
      <React.Fragment>
        {showCardForm
          ? (
          <div className={styles.cardForm}>
            <CardForm onSuccess={onAddPaymentMethodSuccess} />
            <LinkBankAccountButton
              buttonType="link"
              buttonText="Switch to Bank Account"
              extraOnClick={onClickSwitchToBankAccount}
              onLinkAccountSuccess={onAddPaymentMethodSuccess}
            />
          </div>
            )
          : (
          <div className={styles.paymentButtons}>
            <Button name="addCard" onClick={handleAddCard} type="default" data-testid="payment-add-card-button">
              Add a Card
            </Button>
            <span className={styles.orText}>Or</span>
            <LinkBankAccountButton
              extraOnClick={onClickLinkBankAccount}
              onLinkAccountSuccess={onAddPaymentMethodSuccess}
            />
          </div>
            )}
      </React.Fragment>
      {/* )} */}
    </Spin>
  )
}

CardOrBankAccount.defaultProps = {
  onAddCard: () => null,
  onClickLinkBankAccount: () => null,
  onClickSwitchToBankAccount: () => null,
}

export default CardOrBankAccount
